"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InitialsButton = void 0;
const react_1 = __importDefault(require("react"));
const InitialsButton_styles_1 = require("./InitialsButton.styles");
const InitialsButton = ({ label, imageUrl, onClick }) => {
    const isUrl = imageUrl && /^https?:\/\//.test(imageUrl);
    const labelShort = label.length > 2 ? label.slice(0, 2) : label;
    return (react_1.default.createElement(InitialsButton_styles_1.InitialsButtonContainer, { onClick: onClick }, isUrl ? (react_1.default.createElement(InitialsButton_styles_1.ImageWrapper, null,
        react_1.default.createElement("img", { src: imageUrl, alt: "Profile" }))) : (react_1.default.createElement(InitialsButton_styles_1.TitleWrapper, null, labelShort))));
};
exports.InitialsButton = InitialsButton;
//# sourceMappingURL=InitialsButton.js.map